import React from 'react';
import PropTypes from 'prop-types';

const FulfillmentDetails = props => {
  const { address } = props;
  const renderAddressLine1 = address && address.addressLine1 && <div data-rw="fulfillment-details--address--line1">{address.addressLine1}</div>;
  const renderAddressLine2 = address && address.addressLine2 && <div data-rw="fulfillment-details--address--line2">{address.addressLine2}</div>;
  const renderCity = address && address.city && <div data-rw="fulfillment-details--address--city">{address.city}</div>;
  const renderPostcode = address && address.postcode && <div data-rw="fulfillment-details--address--postcode">{address.postcode}</div>;

  return (
    <div>
      {renderAddressLine1}
      {renderAddressLine2}
      {renderCity}
      {renderPostcode}
    </div>
  );
};

FulfillmentDetails.propTypes = {
  address: PropTypes.object.isRequired
};

export default FulfillmentDetails;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/FulfillmentDetails.js